import { FormattedMessage } from "react-intl";
const Content = () => {
    return (
        <div className="text-center text-[#FFFFFF] xl:px-56 xl:pb-12">
            <p className="text-3xl font-normal xl:text-5xl pb-5"><FormattedMessage id="LANDINGPAGE.MAIN.WHY_CHATME" /></p>
            <div className="flex items-center justify-center pb-7">
                <div className="flex items-center">
                    <div className="h-[0.5px] w-12 bg-[#5AE65E] md:h-[1px]"></div>
                    <div className="w-1 h-1 bg-[#5AE65E] md:w-2 md:h-2" style={{ clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}></div>
                    <div className="h-[0.5px] w-12 bg-[#5AE65E] md:h-[1px]"></div>
                </div>
            </div>
            <p className="hidden w-[950px] text-base font-normal lg:block lg:w-full lg:px-16 xl:text-sm 2xl:px-0 2xl:text-base">
                <FormattedMessage id="LANDINGPAGE.MAIN.WHY_CHATME_DESC" />
            </p>
        </div>
    );
};

export default Content;